angular.module('alertApp', ['ngRoute', 'ui.select', 'blockUI'])

angular.module('alertApp').controller 'alertController', ($scope, $http, blockUI) ->

    $scope.init = (query) ->
        $scope.emailFeedback = ""
        $scope.emailGlyphicon = "glyphicon-star"
        $scope.queryFeedback = ""
        $scope.queryGlyphicon = "glyphicon-star"
        $scope.acceptTerms = false
        if query != ""
            $scope.newAlert = {}
            $scope.newAlert.query = query
        $scope.getFormData()

    $scope.checkEmail = () ->
        if validateEmail($scope.newAlert.email)
            $scope.emailFeedback = "has-success"
            $scope.emailGlyphicon = "glyphicon-ok"
        else
            $scope.emailFeedback = "has-error"
            $scope.emailGlyphicon = "glyphicon-remove"

    $scope.checkQuery = () ->
        if $scope.newAlert.query?
            $scope.queryFeedback = "has-success"
            $scope.queryGlyphicon = "glyphicon-ok"
        else
            $scope.queryFeedback = "has-error"
            $scope.queryGlyphicon = "glyphicon-remove"

    validateEmail = (email) ->
        re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        re.test(email)

    $scope.create = (newAlert, csrfToken) ->
        newAlert.category = (cat.value for cat in $scope.categoryPicks when cat.checked)
        newAlert.lang = $scope.picks.lang
        newAlert.website = $scope.picks.website
        newAlert.state = $scope.picks.state
        headers = { "Csrf-Token" : csrfToken }
        config = {headers : headers }
        if $scope.newAlert.query? && validateEmail($scope.newAlert.email) && $scope.acceptTerms is true
            blockUI.start()
            $http.post(jsRoutes.controllers.Alert.createAlert().url, newAlert, config).success( (response, status, headers, config) ->
                addSuccessAlert("Un email d'activation vous a été envoyé.")
            ).error (response, status, headers, config) ->
                addFailAlert("Une erreur s'est produite, veuillez contacter info@scrapeo.com")
            blockUI.stop()
        else
            addFailAlert("Veuillez vérifier les données saisies.")

    $scope.update = (id, newAlert, csrfToken) ->
        newAlert.category = (cat.value for cat in $scope.categoryPicks when cat.checked)
        newAlert.lang = $scope.picks.lang
        newAlert.website = $scope.picks.website
        newAlert.state = $scope.picks.state
        headers = { "Csrf-Token" : csrfToken }
        config = {headers : headers }
        if $scope.newAlert.query?
            blockUI.start()
            $http.post(jsRoutes.controllers.Alert.updateAlert(id).url, newAlert, config).success( (response, status, headers, config) ->
                addSuccessAlert(response)
            ).error (response, status, headers, config) ->
                addFailAlert(response)
            blockUI.stop()
        else
            addFailAlert("Veuillez vérifier les données saisies.")

    $scope.picks = {}
    $scope.picks.lang = []
    $scope.picks.website = []
    $scope.picks.state = []
    $scope.getFormData = () ->
        $http.get(jsRoutes.controllers.Alert.alertFormData().url).success( (response, status, headers, config) ->
            $scope.langOptions =  _.sortBy(response.lang, (elem) -> elem.lang).map (x) -> x.lang
            $scope.websiteOptions = _.sortBy(response.website, (elem) -> elem.sourceWebsite).map (x) -> x.sourceWebsite
            $scope.stateOptions = response.state
            $scope.categoryOptions = if response.category?
                unsorted = response.category.map (x) ->
                    {"label": x.name, "value": x.code, "code": x.code, "checked": true}
                _.sortBy(unsorted, (elem) -> elem.label)
            $scope.categoryPicks = $scope.categoryOptions
            initializeMultiselect()
        ).error (response, status, headers, config) ->
            console.log("pas ok")

    $scope.getPreFilledFormData = (id) ->
        $scope.newAlert = {}
        $scope.getFormData()

        $http.get(jsRoutes.controllers.Alert.updateAlertFormData(id).url).success( (response, status, headers, config) ->
            $scope.getPreFilledFormDataFound = true
            $scope.manageUrl = response.manageUrl
            alertDetails = response.alertDetails
            $scope.newAlert.email = alertDetails.email
            $scope.newAlert.query = alertDetails.userquery
            $scope.newAlert.country = alertDetails.country
            $scope.newAlert.city = alertDetails.city
            $scope.newAlert.zip = alertDetails.zip
            $scope.newAlert.lifespan = alertDetails.lifespan
            $scope.newAlert.frequency = alertDetails.frequency
            $scope.newAlert.priceFrom = alertDetails.priceFrom
            $scope.newAlert.priceTo = alertDetails.priceTo
            $scope.picks.lang = alertDetails.lang if alertDetails.lang?
            $scope.picks.website = alertDetails.websites if alertDetails.websites?
            $scope.picks.state = alertDetails.state if alertDetails.state?
            $scope.categoryPicks = if alertDetails.category?
                multiselectAdjust($("#categoryMultiselect"), alertDetails.category)
                $scope.categoryOptions.map (x) ->
                    if not (x.code in alertDetails.category)
                        x.checked = false
                    x
            else
                $scope.categoryOptions
        ).error (response, status, headers, config) ->
            $scope.getPreFilledFormDataFound = false
            console.log("pas ok")

    initializeMultiselect = () ->
        $("#categoryMultiselect").multiselect(
            {includeSelectAllOption: true,
            onChange: (element, checked) ->
                elemVal = $(element).val()
                if(elemVal == "multiselect-all")
                    k = $scope.categoryPicks.map (x) ->
                        x.checked = checked
                        x
                    $scope.categoryPicks = k
                else if !checked && checkIfAllTrue($scope.categoryPicks.map (x) -> x.checked)
                    k = $scope.categoryPicks.map (x) ->
                        if(x.value.toString() != elemVal)
                            x.checked = checked
                            x
                        else
                            x
                    deselectAll($("#categoryMultiselect"))
                    $("#categoryMultiselect").multiselect('select', elemVal)
                    $("#categoryMultiselect").multiselect('refresh')
                    $scope.categoryPicks = k
                else
                    k = $scope.categoryPicks.map (x) ->
                        if(x.value.toString() == elemVal)
                            x.checked = checked
                            x
                        else
                            x
                    $scope.categoryPicks = k
            ,
            selectAllValue: 'multiselect-all',
            numberDisplayed: 1,
            buttonClass: 'btn btn-orange'
            }
        ).multiselect('dataprovider', $scope.categoryPicks)
        selectAll($("#categoryMultiselect"))

    selectAll = (elem) ->
        $('option', elem).each( (element) ->
              elem.multiselect('select', $(this).val())
        )

    deselectAll = (elem) ->
        $('option', elem).each( (element) ->
              elem.multiselect('deselect', $(this).val())
        )

    multiselectAdjust = (elem, picked) ->
        $('option', elem).each( (element) ->
              if($(this).val().toString() != "multiselect-all")
                  if parseInt($(this).val()) not in picked
                      elem.multiselect('deselect', $(this).val())
        )

    $scope.alertBoxes = []
    addSuccessAlert = (msg) ->
        addAlert({type: 'alert-success', msg: msg})

    addFailAlert = (msg) ->
        addAlert({type: 'alert-danger', msg: msg})

    addAlert = (msg) ->
        $scope.alertBoxes.push(msg)

    $scope.closeAlert = (index) ->
        $scope.alertBoxes.splice(index,1)

    intersection = (candidate, bucket, identifier) ->
        value for value in bucket when value[identifier] in candidate

    checkIfAllTrue = (array) ->
        if array.length != 0
            array.reduce (x, y) -> x and y
        else
            false
